$(document).ready(function () {
    let modal = $('.gen-doc');
    let modalData = modal.find('.gen-doc__attach-docs');
    let checkboxes = $('.practice-report__documents').find('.control__input');

    let arrNames = [];
    let arrDates = [];

    function getCheckedCheckbox() {
        $(checkboxes).each(function (indx) {

            if ($(this).is(':checked')) {
                let names = $(this).parents('.uploaded-doc').find('.uploaded-doc__val._name').text();
                let dates = $(this).parents('.uploaded-doc').find('.uploaded-doc__val._date').text();
                
                //записываем данные выбранных блоков в массивы
                    arrNames.push(names);
                    arrDates.push(dates);
            }
        });
    };

    function genHtml(arrNames, arrDates) {

        for (let i = 0, y = 0; i < arrNames.length, y < arrDates.length; i++ , y++) {

            let structure = `<div class="gen-doc__attach-doc">
            <div class="control">
                <label class="control__label">
                    <input type="checkbox" class="control__input">
                        <span class="control__container">
                            <span class="control__checkbox"></span>
                        </span>
                </label>
            </div>
                <ul class="gen-doc__list">
                    <li class="gen-doc__item _rep">
                        <span class="gen-doc__rep">Отчет по практике</span>
                    </li>
                    <li class="gen-doc__item">
                        <span class="gen-doc__sv">Дата редактирования:</span>
                        <span>${arrDates[y]}</span>
                    </li>
                    <li class="gen-doc__item">
                        <span class="gen-doc__sv">Автор редактирования:</span>
                        <span>${arrNames[i]}</span>
                    </li>
                </ul>
            </div>`
            modalData.append(structure);
        }
    };


    $('.practice-report__gener-doc').on('click', function () {
        getCheckedCheckbox();
        genHtml(arrNames, arrDates);
    })
})